module.exports = __webpack_public_path__ + "public/images/circular-background-pattern-1.0a91e26762ba47f9cc45edf6a04e07da.svg";